import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {environment} from "../../../../environments/environment";
import {HttpService} from "../../../services/http.service";

@Component({
  selector: 'app-ai-structure-cell',
  templateUrl: './ai-structure-cell.component.html',
  styleUrls: ['./ai-structure-cell.component.scss']
})
export class AiStructureCellComponent implements ICellRendererAngularComp {
  private params!: ICellRendererParams;
  public value: any = '';
  public pending: boolean = false;
  public message: string = '';
  public activeBtn: boolean = false;
  constructor(
    private httpService: HttpService,
  ) {
    this.activeBtn = window.location.pathname === '/grid';
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    if (this.params.value && this.params.value.message) {
      this.message = this.params.value.message;
    } else if (this.params.value) {
      // this.value = this.params.value.split(' > ');
      this.value = this.params.value;
    }
  }

  clear() {
    const node: any = this.params.node.data;
    const updateData = {
      product_id: node._id,
      payload: {
        collections: [],
      }
    };
    this.httpService.patch(environment.API_PATH + '/product/stage', updateData).subscribe(resp => {
      // this.toastService.success(resp.message);
    });
  }
  regenerate() {
    this.pending = true;
    const pid = this.params.node.data.product_id;
    const shopify_id = this.params.node.data.shopify_id;
    this.httpService.post(environment.API_PATH + '/ai/get-collections-for-product', {ids: [pid], shopify_id }).subscribe(response => {
      setTimeout(() => {
        this.pending = false;
        if (response && response.message) {
          this.message = response.message;
        } else {
          // this.value = response;
          const node: any = this.params.node.data;
          // node.status = 20;
          // node.collections = response;
          // console.log('node', node);
          // this.params.node.setData(node);
          const updateData = {
            product_id: node._id,
            payload: {
              collections: response,
            }
          };
          this.httpService.patch(environment.API_PATH + '/product/stage', updateData).subscribe(resp => {
            // this.toastService.success(resp.message);
          });
        }
      }, 400);
      // this.gridService.aiFineTuneGptCompleteEvent.next(true);
    });
  }
  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.value, event.previousIndex, event.currentIndex);
  }
  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  stopPropagation(event: any){
    event.stopPropagation();
  }
}
